// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { Locale } from 'jsw';
import { ContentLoader, Markdown, Icon, Cuttable } from '@plesk/ui-library';
import { useSearchParams } from 'react-router-dom';
import { useContext } from 'react';
import { Answer, CopilotContext } from '../../CopilotContext';

const Translate = Locale.getTranslate('components.search-bar');

type CopilotResultProps = {
    answer?: string;
    loading: boolean;
    term: string;
}

const CopilotSearchResult = ({ answer, loading, term }: CopilotResultProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setSearchParams] = useSearchParams();


    const { answers, setAnswers } = useContext(CopilotContext);

    const openDrawer = () => {
        if (answer) {
            const newAnswers: Answer[] = [
                ...answers,
                { role: 'user', id: answers.length, content: term },
                { role: 'assistant', id: answers.length + 1, content: answer },
            ];

            setAnswers(newAnswers);
            setSearchParams(prev => {
                prev.append('copilot', '');
                return prev;
            });
        } else {
            setSearchParams(prev => {
                prev.append('copilot', term);
                return prev;
            });
        }
    };

    return (
        <div className="plesk-copilot-search-result" onClick={openDrawer}>
            {loading ?
                <ContentLoader className="plesk-copilot-loading-indicator" text={<Translate content={'copilot.loader-text'} />} /> :
                <div>
                    {!!answer &&
                        <div className="plesk-copilot-search-answer">
                            <Icon src={require('images/AI.svg')} />
                            <div>
                                <Cuttable collapsed maxHeight="100px">
                                    <Markdown>{answer}</Markdown>
                                </Cuttable>
                                <a><Translate content={'copilot.showMore'} /></a>
                            </div>
                        </div>}
                </div>}
        </div>
    );
};

export default CopilotSearchResult;
